import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";


import { CasinoLink } from '../Layout/CasinoLink.jsx'



export class AccountLinkovi extends React.Component {

    constructor(props) {
        super(props);
        this.startChat = this.startChat.bind(this);
    }



    startChat() {
        this.props.showLoadingFn(true);
        var nadimak = this.props.user.nadimak;
        var chatToken = this.props.user.chatToken;

        if (!this.props.pozzitoStartedFn()) {
            beebeeate_config.user_data = {
                externalId: chatToken,
                username: nadimak,
                firstname: nadimak
            }

            var instance = BeeBeeate.widget.new(beebeeate_config);
            this.props.pozzitoStartedFn(true, instance);
        };

        this.showChatInterval = setInterval(() => {
            if (document.getElementsByClassName("beebeeate-btn-show").length) {
                clearInterval(this.showChatInterval);

                setTimeout(() => {
                    var bubleElement = document.getElementsByClassName("beebeeate-btn-show")[0];

                    // ako se nije otvorio onda ga otvori
                    if (bubleElement.parentElement.className.indexOf('hide') == -1) {
                        bubleElement.click();
                    }
                    this.props.showLoadingFn(false);
                }, 250);
            }
        }, 1500)

    }


    render() {
        return <div>
            {/* <a className="link link-20" onClick={(e) => { e.preventDefault(); this.startChat(); }}><span>Chat podrška</span></a>
            <hr /> */}
            <NavLink to={this.props.getHomePathFn(this.props.route.location, '/account/bonuses')} className='link link-20' >
                <span>Bonusi</span>
            </NavLink> 
             <hr />

            <NavLink to={this.props.getHomePathFn(this.props.route.location, '/account/superklub')} className='link link-20' >
                <span>SuperKlub</span>
            </NavLink>
            <hr />

            <NavLink to={this.props.getHomePathFn(this.props.route.location, '/account/superspin')} className='link link-20' >
                <span>SuperSpin</span>
            </NavLink>
            <hr />

            <NavLink to={this.props.getHomePathFn(this.props.route.location, '/obavijesti')} className='link link-20' >
                <span>Obavijesti</span>
            </NavLink>
            <hr />
            {/* <NavLink to={this.props.getHomePathFn(this.props.route.location, '/account/games')} className='link link-20' >
                <span>Odigrane igre</span>
            </NavLink> */}
            {/* <hr /> */}
            {/* <NavLink to={this.props.getHomePathFn(this.props.route.location, '/account/transactions')} className='link link-20' >
                <span>Transakcije</span>
            </NavLink> */}
            {/* <hr /> */}
            <NavLink to={this.props.getHomePathFn(this.props.route.location, 'account/privacy')} className='link link-20' >
                <span>Postavke privatnosti</span>
            </NavLink>
            <hr />
            <NavLink to={this.props.getHomePathFn(this.props.route.location, '/vip')} className='link link-20' >
                <span>Vip</span>
            </NavLink>
            <hr />

            {<CasinoLink className="link link-20" href={casino.config.urls.web + "racun/superpredah"}><span>SuperPredah</span><span className="icon ico-expand-outline"></span></CasinoLink>}
            {this.props.user.imaSamoogranicenje && <hr />}
            {this.props.user.samoIskljucen && <a className="link link-20" href="https://m.supersport.hr/racun#/samoiskljucenje" target="_blank">Samoisključenje</a>}
            {this.props.user.samoIskljucen && <hr />}
            <CasinoLink className="link link-20" href={casino.config.urls.sportRacun}><span>Sport račun</span><span className="icon ico-expand-outline"></span></CasinoLink>
        </div>
    }
};
